import { useEffect, useState, useCallback, useMemo } from 'react';
import { CACHE_DEFAULTS } from 'legacyfrontend/constants';
import { useFlightContext } from 'legacyfrontend/contexts/FlightDetailsContext';
import { getCacheStatus, setCacheStatus } from 'legacyfrontend/helpers/getCacheStatus';

export const useRefreshModal = () => {
  const [showRefreshModal, setShowRefreshModal] = useState(false);
  const { expCacheDate } = useFlightContext();
  const [hasExpired, setHasExpired] = useState(false);

  const timeUntilExpiration = useMemo(
    () =>
      expCacheDate
        ? new Date(expCacheDate).getTime() - Date.now()
        : CACHE_DEFAULTS.DEFAULT_EXPIRATION_TIME,
    [expCacheDate]
  );

  useEffect(() => {
    if (getCacheStatus() !== true) {
      setCacheStatus('true');
    }
    setHasExpired(false);
  }, [expCacheDate]);

  const handleRefreshConfirm = useCallback((onRefresh) => {
    setShowRefreshModal(false);

    if (onRefresh) {
      setCacheStatus('false');
      onRefresh();
    }
  }, []);

  useEffect(() => {
    if (!expCacheDate || hasExpired || timeUntilExpiration <= 0) return;

    const timerId = setTimeout(() => {
      setShowRefreshModal(true);
      setHasExpired(true);
      setCacheStatus('false');
    }, timeUntilExpiration);

    return () => {
      clearTimeout(timerId);
    };
  }, [expCacheDate, timeUntilExpiration, hasExpired]);

  return {
    showRefreshModal,
    setShowRefreshModal,
    handleRefreshConfirm,
  };
};
